"use client";

import { useExpertMap } from "@/app/(platform)/copilot/useExpertMap";
import { Badge } from "@/components/atoms/Badge/Badge";
import { ExpertAvatar } from "@/components/molecules/ExpertAvatar/ExpertAvatar";
import { cn } from "@/lib/utils";

interface Props {
  expertId: string | null | undefined;
  className?: string;
}

export function ExpertBadge({ expertId, className }: Props) {
  const { expertsById } = useExpertMap();
  const expert = expertId ? expertsById.get(expertId) : undefined;
  if (!expert) return null;

  return (
    <span
      className={cn("inline-flex items-center", className)}
      title={`From ${expert.name}`}
      data-testid="artifacts-expert-badge"
    data-sentry-component="ExpertBadge" data-sentry-source-file="ExpertBadge.tsx">
      {/* oxlint-disable-next-line design-system/no-restyle -- the avatar sits nearer the edge than a label; Badge has no leading-avatar size */}
      <Badge variant="info" size="small" className="pl-1" data-sentry-element="Badge" data-sentry-source-file="ExpertBadge.tsx">
        <span aria-hidden className="flex shrink-0">
          <ExpertAvatar
            name={expert.name}
            avatarUrl={expert.avatarUrl}
            size={14}
          data-sentry-element="ExpertAvatar" data-sentry-source-file="ExpertBadge.tsx" />
        </span>
        {expert.name}
      </Badge>
    </span>
  );
}
